<template>
  <div class="footer-components">
    <div class="footer-wrapper">
      <div class="footer-top">
        <div class="footer-item">
          <div class="title">{{ $t('footerData.title_products') }}</div>
          <div class="list">
            <div class="list-item" v-for="(item, index) in typeList" :key="index" v-show="index < 4" @click="goPage(item)">
              {{ (currentLanguage === 'zh') ? item.nameZh : item.nameEn }}
            </div>
            <div class="list-item" v-if="typeList.length > 4" @click="goPage()">{{ $t('footerData.more') }}</div>
          </div>
        </div>

        <div class="footer-item">
          <div class="title">{{ $t('footerData.title_mall_and_design') }}</div>
          <div class="list">
            <div class="list-item" @click="goLink(urlList.mall)">
              {{ $t('footerData.wellingmer_mall') }}
            </div>
            <div class="list-item" @click="goLink(urlList.design)">
              {{ $t('footerData.design_center') }}
            </div>
          </div>
        </div>

        <div class="footer-item udi">
          <div class="title">{{ $t('footerData.title_udi_search') }}</div>
          <div class="search" @click="goLink(urlList.udi)">
            <div class="search-left">{{ $t('footerData.query_placeholder') }}</div>
            <div class="search-right">{{ $t('footerData.query') }}</div>
          </div>
        </div>

        <div class="footer-item qr">
          <div class="title">{{ $t('footerData.title_follow_wellingmer') }}</div>
          <img :src="`${$baseUrl + contactUs.qrCode}`" alt="" />
        </div>

        <div class="footer-item">
          <div class="title">{{ $t('footerData.title_contact_us') }}</div>
          <div class="list">
            <div class="list-item">
              {{ $t('footerData.phone') + '：' + contactUs.contactPhone }}
            </div>
            <div class="list-item">
              {{ $t('footerData.email') + '：' + contactUs.contactEmail }}
            </div>
            <div class="list-item">
              {{ $t('footerData.address') + '：' }}
              {{ (currentLanguage === 'zh') ? contactUs.contactPathZh : contactUs.contactPathEn }}
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <img :src="require(`@/assets/logo-new-20250214.png`)" alt="" />
        <div class="sign">
          <span>{{ contactUs.copyright }}</span>
          <span @click="goIcpWebsite" style="color: #888888;">{{ contactUs.icpLicense }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexProductType } from "@/api/products";
import { getContactUs } from "@/api/company";
import { getLinkByName } from "@/api/links";
export default {
  name: "Footer",
  data() {
    return {
      typeList: [],
      contactUs: {},
      urlList: {
        udi: '',
        mall: '',
        design: ''
      },
      udiLink: "",
    };
  },
  created() {
    this.init();
  },
  computed: {
    // 当前语言
    currentLanguage() {
      return this.$store.state.language.currentLanguage;
    }
  },
  methods: {
    init() {
      getIndexProductType().then(res => {
        this.typeList = res.data.data;
      });

      getContactUs().then(res => {
        this.contactUs = res.data.data;
      });

      getLinkByName({ name: "UDI查询" }).then((response) => {
        this.urlList.udi = response.data.data[0].linkUrl;
      });
      getLinkByName({ name: "跳转至商城" }).then((response) => {
        this.urlList.mall = response.data.data[0].linkUrl;
      });
      getLinkByName({ name: "跳转至设计中心" }).then((response) => {
        this.urlList.design = response.data.data[0].linkUrl;
      });
    },
    goPage(data) {
      if (data) {
        this.$router.push({ path: "/products", query: { typeData: data } });
      } else {
        this.$router.push("/products");
      }
    },
    goLink(url) {
      if(!url || url === "#" ) return; // 空 或者为 # 不跳转
      window.open(url, "_blank");
    },
    goIcpWebsite()
    {
      window.open('https://beian.miit.gov.cn')
      //window.location = 'https://beian.miit.gov.cn';  
    },
  },
};
</script>

<style lang="scss">
.footer-components {
  background: #333333;
  color: #ffffff;

  .footer-wrapper {
    @include flex(center, center, column);
    padding: 40px 0px;

    .footer-top {
      @include flex(space-between);
      padding: 0px 0px 40px;

      .footer-item {
        padding: 0px 35px;

        .title {
          margin-bottom: 20px;
          font-size: 18px;
        }

        .list {
          color: rgba(206, 206, 206, 1);
          font-size: 14px;

          .list-item {
            margin-bottom: 10px;
            max-width: 300px;

            &:hover {
              color: #ffffff;
              text-decoration: underline;
            }
          }
        }

        .search {
          @include flex;
          border-radius: 44px;
          width: 200px;
          height: 30px;
          background-color: #ffffff;
          overflow: hidden;

          .search-left {
            padding-left: 5px;
            width: 60%;
            color: rgba(193, 194, 197, 1);
            font-size: 12px;
            text-align: left;
            line-height: 30px;
          }

          .search-right {
            width: 40%;
            background-color: $main-color;
            font-size: 13px;
            text-align: center;
            line-height: 30px;
          }
        }
      }

      .udi,
      .qr {
        @include flex($align: center, $direction: column);

        img {
          width: 90px;
          height: 90px;
        }
      }
    }

    .footer-bottom {
      @include flex($align: center);
      width: 1100px;
      padding: 40px 0px 0px;
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      font-size: 12px;

      img {
        width: 150px;
        // height: 30px;
      }

      .sign {
        margin-left: 80px;
      }
    }
  }
}

/* 超大屏幕样式 */
@media only screen and (min-width: 1550px) {
  .footer-components {
    .footer-wrapper {
      padding: 60px 0px;

      .footer-top {
        padding: 0px 0px 60px;

        .footer-item {
          padding: 0px 45px;

          .title {
            margin-bottom: 20px;
            font-size: 20px;
          }

          .list {
            font-size: 16px;

            .list-item {
              margin-bottom: 10px;
              max-width: 350px;
            }
          }

          .search {
            width: 300px;
            height: 40px;

            .search-left {
              padding-left: 10px;
              font-size: 14px;
              line-height: 40px;
            }

            .search-right {
              font-size: 16px;
              line-height: 40px;
            }
          }
        }

        .qr {
          img {
            width: 143px;
            height: 143px;
          }
        }
      }

      .footer-bottom {
        width: 1440px;
        padding: 60px 0px 0px;
        font-size: 18px;

        img {
          width: 240px;
          // height: 44px;
        }

        .sign {
          margin-left: 80px;
        }
      }
    }
  }
}

/* 手机样式 */
@media only screen and (max-width: 767px) {
  .footer-components {
    .footer-wrapper {
      @include flex(center, center, column);
      padding: 25px 20px;

      .footer-top {
         //@include flex(space-between, center, column);
        @include flex(space-between, center);
         flex-wrap: wrap;
         align-items: flex-start;
        padding: 0px 0px 15px;

        .footer-item {
          padding: 15px 0px;

          .title {
            text-align: center;
            margin-bottom: 20px;
            font-size: 16px;
          }

          .list {
            .list-item {
              text-align: center;
            }
          }

          .search {
            width: 200px;
            height: 30px;

            .search-left {
              line-height: 30px;
            }

            .search-right {
              line-height: 30px;
            }
          }
        }

        .udi,
        .qr {
          @include flex($align: center, $direction: column);

          img {
            width: 90px;
            height: 90px;
          }
        }
      }

      .footer-bottom {
        @include flex(center, center, column);
        width: auto;
        padding: 15px 0px 0px;
        border-top: none;

        img {
          margin-bottom: 10px;
          width: 120px;
          // height: 20px;
        }

        .sign {
          @include flex(center, center, column);
          margin-left: 0px;
          text-align: center;

          span {
            margin-top: 10px;
          }
        }
      }
    }
  }
}
</style>
